import { render, staticRenderFns } from "./selectAdversing.vue?vue&type=template&id=06beef7b&"
import script from "./selectAdversing.vue?vue&type=script&lang=js&"
export * from "./selectAdversing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports